export default __webpack_public_path__ + "static/check-to-slot-light.png";